/** Translation keys used in the framework */
export const enum FrameworkTextKey {
    Back = 'Back',
    BirthDateInvalidErrorMessage = 'BirthDateInvalidErrorMessage',
    Cancel = 'Cancel',
    CharactersLeft = 'CharactersLeft',
    ChargingZeroAmountErrorMessage = 'ChargingZeroAmountErrorMessage',
    ChartEmptyDefaultMessage = 'ChartEmptyDefaultMessage',
    ChartErrorDefaultMessage = 'ChartErrorDefaultMessage',
    ChooseFile = 'ChooseFile',
    ClearFilters = 'ClearFilters',
    Clear = 'Clear',
    ClearSelection = 'ClearSelection',
    ClearTheSignature = 'ClearTheSignature',
    ClickToClose = 'ClickToClose',
    Close = 'Close',
    CloseBanner = 'CloseBanner',
    CloseDialog = 'CloseDialog',
    CollapseAccordion = 'CollapseAccordion',
    ConfigureProductDetailsProductImageFileTypeError = 'ConfigureProductDetailsProductImageFileTypeError',
    Contains = 'Contains',
    Custom = 'Custom',
    Day = 'Day',
    DayFriday = 'DayFriday',
    DayMonday = 'DayMonday',
    DayPlural = 'DayPlural',
    DaySaturday = 'DaySaturday',
    DayShortFriday = 'DayShortFriday',
    DayShortMonday = 'DayShortMonday',
    DayShortSaturday = 'DayShortSaturday',
    DayShortSunday = 'DayShortSunday',
    DayShortThursday = 'DayShortThursday',
    DayShortTuesday = 'DayShortTuesday',
    DayShortWednesday = 'DayShortWednesday',
    DaySunday = 'DaySunday',
    DayThursday = 'DayThursday',
    DayTuesday = 'DayTuesday',
    DayWednesday = 'DayWednesday',
    Days = 'Days',
    Decrement = 'Decrement',
    Error = 'Error',
    ExpandAccordion = 'ExpandAccordion',
    Format = 'Format',
    Increment = 'Increment',
    Information = 'Information',
    DeselectAll = 'DeselectAll',
    DialogedDatePickerCancel = 'DialogedDatePickerCancel',
    DropzoneFileLimitOverReachedError = 'DropzoneFileLimitOverReachedError',
    DropzoneFileLimitReached = 'DropzoneFileLimitReached',
    Failed = 'Failed',
    FileSizeLargerThanAllowed = 'FileSizeLargerThanAllowed',
    FilesAreNotSupportedErrorMessage = 'FilesAreNotSupportedErrorMessage',
    FilterBySearch = 'FilterBySearch',
    GeneralCustom = 'GeneralCustom',
    GreaterThan = 'GreaterThan',
    Help = 'Help',
    HideColumn = 'HideColumn',
    Hour = 'Hour',
    Hours = 'Hours',
    InputError = 'InputError',
    InvalidServiceOrderEndErrorMessage = 'InvalidServiceOrderEndErrorMessage',
    InvalidUrlErrorMessage = 'InvalidUrlErrorMessage',
    ItemPlural = 'ItemPlural',
    ItemSingular = 'ItemSingular',
    ItemsSelected = 'ItemsSelected',
    ItemsSelectedOfTotal = 'ItemsSelectedOfTotal',
    LastMonth = 'LastMonth',
    LastQuarter = 'LastQuarter',
    LastWeek = 'LastWeek',
    LastYear = 'LastYear',
    Loading = 'Loading',
    LoadMore = 'LoadMore',
    MaximumTextLengthErrorMessage = 'MaximumTextLengthErrorMessage',
    MewsLogo = 'MewsLogo',
    Month = 'Month',
    MonthApril = 'MonthApril',
    MonthAugust = 'MonthAugust',
    MonthDecember = 'MonthDecember',
    MonthFebruary = 'MonthFebruary',
    MonthJanuary = 'MonthJanuary',
    MonthJuly = 'MonthJuly',
    MonthJune = 'MonthJune',
    MonthMarch = 'MonthMarch',
    MonthMay = 'MonthMay',
    MonthNovember = 'MonthNovember',
    MonthOctober = 'MonthOctober',
    MonthSeptember = 'MonthSeptember',
    MonthShortApril = 'MonthShortApril',
    MonthShortAugust = 'MonthShortAugust',
    MonthShortDecember = 'MonthShortDecember',
    MonthShortFebruary = 'MonthShortFebruary',
    MonthShortJanuary = 'MonthShortJanuary',
    MonthShortJuly = 'MonthShortJuly',
    MonthShortJune = 'MonthShortJune',
    MonthShortMarch = 'MonthShortMarch',
    MonthShortMay = 'MonthShortMay',
    MonthShortNovember = 'MonthShortNovember',
    MonthShortOctober = 'MonthShortOctober',
    MonthShortSeptember = 'MonthShortSeptember',
    Months = 'Months',
    MultipleFileDropNotAllowedErrorMessage = 'MultipleFileDropNotAllowedErrorMessage',
    NextMonth = 'NextMonth',
    NextQuarter = 'NextQuarter',
    NextWeek = 'NextWeek',
    NextYear = 'NextYear',
    Night = 'Night',
    NightPlural = 'NightPlural',
    NoDataAvailable = 'NoDataAvailable',
    NoItems = 'NoItems',
    NoResultsForSearch = 'NoResultsForSearch',
    NotSelected = 'NotSelected',
    NumberNotGreaterThanOrEqualToErrorMessage = 'NumberNotGreaterThanOrEqualToErrorMessage',
    NumberPickerValidationErrorMessage = 'NumberPickerValidationErrorMessage',
    Of = 'Of',
    Ok = 'Ok',
    Optional = 'Optional',
    Or = 'Or',
    PaginationItems = 'PaginationItems',
    PasswordWeakErrorMessage = 'PasswordWeakErrorMessage',
    PauseVideo = 'PauseVideo',
    PaymentStatePending = 'PaymentStatePending',
    PerDay = 'PerDay',
    PerHour = 'PerHour',
    PerMonth = 'PerMonth',
    PerNight = 'PerNight',
    PlayVideo = 'PlayVideo',
    PreviousMonth = 'PreviousMonth',
    Remove = 'Remove',
    Required = 'Required',
    ResetToDefault = 'ResetToDefault',
    Search = 'Search',
    SelectAll = 'SelectAll',
    SelectDate = 'SelectDate',
    SelectMonth = 'SelectMonth',
    SignatureInput = 'SignatureInput',
    Selected = 'Selected',
    SelectedAsStartDate = 'SelectedAsStartDate',
    SelectedAsEndDate = 'SelectedAsEndDate',
    SelectEmptyMessage = 'SelectEmptyMessage',
    SelectedDays = 'SelectedDays',
    SelectedHours = 'SelectedHours',
    SelectedMonths = 'SelectedMonths',
    SelectedNights = 'SelectedNights',
    Show = 'Show',
    ShowAll = 'ShowAll',
    SortAscending = 'SortAscending',
    SortDescending = 'SortDescending',
    Success = 'Success',
    SyncingDataToasterPrimaryText = 'SyncingDataToasterPrimaryText',
    TableClearFilters = 'TableClearFilters',
    TableCollapseAllGroups = 'TableCollapseAllGroups',
    TableColumnSettings = 'TableColumnSettings',
    TableDragToReorder = 'TableDragToReorder',
    TableEmptyStatePrimary = 'TableEmptyStatePrimary',
    TableExpandAllGroups = 'TableExpandAllGroups',
    TableFilterBySearch = 'TableFilterBySearch',
    TableFilterContains = 'TableFilterContains',
    TableFilterGreaterThan = 'TableFilterGreaterThan',
    TableHeaderSearch = 'TableHeaderSearch',
    TablePaginationItemsCount = 'TablePaginationItemsCount',
    TablePaginationShow = 'TablePaginationShow',
    TablePaginationSizeItemsCount = 'TablePaginationSizeItemsCount',
    TablePinLeft = 'TablePinLeft',
    TablePinRight = 'TablePinRight',
    TableSortAscending = 'TableSortAscending',
    TableSortClear = 'TableSortClear',
    TableSortDescending = 'TableSortDescending',
    TableUngroupAll = 'TableUngroupAll',
    TableFilterAfter = 'TableFilterAfter',
    TableFilterBefore = 'TableFilterBefore',
    TableFilterBetween = 'TableFilterBetween',
    TableFilterEndsWith = 'TableFilterEndsWith',
    TableFilterEquals = 'TableFilterEquals',
    TableFilterGreaterThanOrEqual = 'TableFilterGreaterThanOrEqual',
    TableFilterIn = 'TableFilterIn',
    TableFilterLessThan = 'TableFilterLessThan',
    TableFilterLessThanOrEqual = 'TableFilterLessThanOrEqual',
    TableFilterNotIn = 'TableFilterNotIn',
    TableFilterStartsWith = 'TableFilterStartsWith',
    TableFilterFrom = 'TableFilterFrom',
    TableFilterTo = 'TableFilterTo',
    TableGroupBy = 'TableGroupBy',
    TableGroupByLabel = 'TableGroupByLabel',
    TableGroupByNone = 'TableGroupByNone',
    TableGroupByThisColumn = 'TableGroupByThisColumn',
    TableGroupColumnHeader = 'TableGroupColumnHeader',
    TableUnpin = 'TableUnpin',
    ThisMonth = 'ThisMonth',
    ThisQuarter = 'ThisQuarter',
    ThisWeek = 'ThisWeek',
    ThisYear = 'ThisYear',
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    ValidateCVV = 'ValidateCVV',
    ValidateDate = 'ValidateDate',
    ValidateEmail = 'ValidateEmail',
    ValidateFormattedNumber = 'ValidateFormattedNumber',
    ValidateGUID = 'ValidateGUID',
    ValidateIban = 'ValidateIban',
    ValidateNumber = 'ValidateNumber',
    ValidateNumberUpperBound = 'ValidateNumberUpperBound',
    ValidatePasswordContainsLowercaseLetters = 'ValidatePasswordContainsLowercaseLetters',
    ValidatePasswordContainsNumbers = 'ValidatePasswordContainsNumbers',
    ValidatePasswordContainsUppercaseLetters = 'ValidatePasswordContainsUppercaseLetters',
    ValidatePasswordSatifiesMinimumLength = 'ValidatePasswordSatifiesMinimumLength',
    ValidatePasswordSatifiesSpecialCharacters = 'ValidatePasswordSatifiesSpecialCharacters',
    ValidatePaymentCard = 'ValidatePaymentCard',
    ValidatePaymentCardExpiration = 'ValidatePaymentCardExpiration',
    ValidatePaymentCardType = 'ValidatePaymentCardType',
    ValidatePhoneNumber = 'ValidatePhoneNumber',
    ValidatePositiveNumber = 'ValidatePositiveNumber',
    ValidateRequired = 'ValidateRequired',
    ValidateTime = 'ValidateTime',
    Warning = 'Warning',
    Yesterday = 'Yesterday',
}
